const wowApp = require('angular').module('wowApp.shop');

wowApp.service('ShopperService', ['Restangular', 'CurrentUserService', 'SessionContext', 'AgeCalculatorService', '$rootScope', require('./shopper-service')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shopper/index.js
 **/